<template>
  <v-list-item @click="goToNotification(notification)">
    <template>
      <v-list-item-avatar>
        <v-icon class="blue white--text" v-text="getNotificationIcon(notification.type)"></v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="notification-title" v-text="getNotificationTitle(notification.type)"></v-list-item-title>
        <v-list-item-subtitle class="notification-message" v-text="notification.message"></v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-list-item-action-text v-text="dateFormat(notification.creation_date, 'D MMM')"></v-list-item-action-text>
        <v-icon v-if="notification.status === 'read'" color="grey lighten-1">
          visibility
        </v-icon>
        <v-icon v-else color="blue">
          visibility
        </v-icon>
      </v-list-item-action>
    </template>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import { dateFormat } from '@/shared/format'
import { getNotificationIcon, getNotificationTitle } from '@/shared/notification'

export default {
  name: 'NotificationItem',
  mixins: [navigationMixin],
  data () {
    return {
      dateFormat,
      getNotificationIcon,
      getNotificationTitle
    }
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions('notification', ['updateNotification']),
    goToNotification (notification) {
      if (notification.status === 'unread') {
        notification.status = 'read'
        this.updateNotification(notification)
      }

      this.$emit('closeMenu')
      this.goTo(notification.url)
    }
  }
}
</script>

<style scoped>
.notification-title {
  font-size: 0.875rem;
  font-weight: 500;
}
.notification-message {
  font-size: 0.813rem;
  white-space: break-spaces;
}
</style>
